import { createAction, props } from '@ngrx/store';
import { IResponseCluster } from '../../interfaces/cluster';

//139172 – Tool per la rilevazione stato del PuntoPoste
export const PATCH_INATTIVITA_CLUSTER = createAction(
'[Cluster] patch inattivita cluster',
props<{ id: string, patchData: any }>()
);

export const PATCH_INATTIVITA_CLUSTER_SUCCESS = createAction(
'[Cluster] patch inattivita cluster success',
props<{ operationCluster: IResponseCluster }>()
);